<template>
  <div>
    <div class="es-op-box">
      <el-input placeholder="请输入型号名" v-model="queryObj.keyWord" size="small" class="query" style="float: left" clearable
        @change="() => { this.queryObj.pageNum = 1; loadModelList() }">
        <i slot="suffix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-select style="float: left;" class="query" size="small" v-model="queryObj.factoryId" placeholder="请选择厂家"
        clearable filterable @clear="() => { this.queryObj.pageNum = 1; delete this.queryObj.factoryId; loadModelList() }"
        @change="() => { this.queryObj.pageNum = 1; loadModelList() }">
        <el-option v-for="item in factories" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <el-select style="float: left;" class="query" size="small" v-model="queryObj.typeId" placeholder="请选择设备类型" clearable
        filterable @clear="() => { this.queryObj.pageNum = 1; delete this.queryObj.typeId; loadModelList() }"
        @change="() => { this.queryObj.pageNum = 1; loadModelList() }">
        <el-option v-for="item in types" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <el-button type="primary" icon="el-icon-font el-icon-web__tianjia" size="mini" style="margin-right:6px"
        @click="add_init">新增</el-button>
      <es-delete @del="del()" type="button"></es-delete>
    </div>
    <el-table :data="pageData.list" ref="modelTable" border stripe size="mini" height="calc(100vh - 180px)"
      v-loading="loading">
      <el-table-column type="selection" width="40" align="center">
      </el-table-column>
      <el-table-column type="index" label="序号" width="50" align="center">
      </el-table-column>
      <el-table-column prop="name" label="型号名">
      </el-table-column>
      <el-table-column prop="factoryName" label="所属厂家">
      </el-table-column>
      <el-table-column prop="typeName" label="设备类型">
      </el-table-column>
      <el-table-column label="操作" width="120" align="center">
        <template slot-scope="scope">
          <el-link :underline="false" title="附件" @click="edit_file(scope.row)" type="primary"><i
              class="el-icon-upload "></i></el-link>
          <el-divider direction="vertical"></el-divider>
          <el-link :underline="false" title="编辑" @click="edit_init(scope.row)" type="primary"><i
              class="el-icon-font el-icon-bianji"></i></el-link>
          <el-divider direction="vertical"></el-divider>
          <es-delete @del="del(scope.row.id)" :key="scope.row.id" type="icon"></es-delete>
        </template>
      </el-table-column>
    </el-table>
    <div class="es-page-box">
      <es-pagination :data="pageData" @change="(cpage) => { this.queryObj.pageNum = cpage; this.loadModelList() }">
      </es-pagination>
    </div>
    <el-dialog :visible.sync="dialogFileVisible" @closed="() => {this.init()}" width="800px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>附件编辑
      </span>
      <div style="margin-top: 10px;" v-loading="loadingFile">
        <el-divider><span style="color:#409eff">文件附件</span></el-divider>
        <el-upload v-if="modelInfo.id!=null&&modelInfo.id!=''" :action="getUploadAction()" accept=".doc,.xls,.ppt,.pdf,.docx,.xlsx,.pptx,.pptm"
            :beforeUpload="beforeUpload" :headers="{ token: this.$store.getUser().token, platform: 'web' }"
            :show-file-list="false" :file-list="modelFileList" :on-success="handleSuccess" :on-error="handleError"
            :on-exceed="handleExceed" :limit="3" :data="{ busCode: 'assetmodel', type: 'files' }">
            <el-button style="float: right;" size="mini" type="primary">附件</el-button>
          </el-upload>
        <el-table :data="modelFileList" ref="assetModelFileTable" border stripe size="mini" width="100%">
          <el-table-column type="index" label="序号" width="50" align="center">
          </el-table-column>
          <el-table-column prop="name" width="" label="文件名称">
          </el-table-column>
          <el-table-column prop="size" width="" label="文件大小(KB)">
            <template slot-scope="scope">
              {{ (scope.row.size / 1024).toFixed(1) }}
            </template>
          </el-table-column>
          <el-table-column width="80" label="操作" align="center">
            <template slot-scope="scope">
              <el-link :underline="false" title="附件" @click="downFile(scope.row)" type="primary"><i
                  class="el-icon-download"></i></el-link>
              <el-divider direction="vertical"></el-divider>
              <es-delete @del="delFile(scope.row)" :key="scope.row.id" type="icon"></es-delete>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <es-img :info="modelInfo" :fileList="fileList" busCode="assetmodel" dataUrl="/base/model/edit_attach_imgs" type="edit"
          :max="20" tip="图片大小不能超过5MB。图片数量不能超过20张。"
          @insertAttachImgs="(attachImgs) => { this.$set(this.modelInfo, 'attachImgs', attachImgs) }"></es-img>
    </el-dialog>
    <!--编辑型号-->
    <el-dialog :visible.sync="editVisible" @closed="() => {this.$refs['modelForm'].clearValidate(); this.init()}" width="500px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>编辑型号
      </span>
      <el-form :model="modelInfo" :rules="rules" size="mini" label-position="right" label-width="150px" ref="modelForm">
        <el-form-item prop="name" label="型号名称">
          <el-input v-model="modelInfo.name" placeholder="请输入型号名称" style="width:200px" clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="factoryId" label="所属厂家">
          <el-select ref="factorySelect" style="width:200px" size="mini" v-model="modelInfo.factoryId" placeholder="请选择厂家"
            clearable filterable>
            <el-option v-for="item in factories" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="typeId" label="设备类型">
          <el-select ref="typeSelect" style="width:200px" size="mini" v-model="modelInfo.typeId" placeholder="请选择设备类型"
            clearable filterable>
            <el-option v-for="item in types" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini" @click="editVisible = false">取 消</el-button>
        <el-button type="primary" size="mini" @click="submitModel()" :loading="saving">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'model',
  props: ["funcs"],
  data () {
    return {
      factories: [],
      types: [],
      queryObj: { pageNum: 1, pageSize: 20 },//查询条件
      pageData: {},
      fileList: [],
      modelFileList:[],
      editVisible: false,
      dialogFileVisible: false,
      modelInfo: {},//型号信息
      rules: {//验证条件
        // name: [
        //   { required: true, message: '请输入型号名称', trigger: 'blur' },
        //   { max: 50, message: '不能超过50个字符', trigger: 'blur' }
        // ],
        factoryId: [
          { required: true, message: '请选择厂家', trigger: 'blur' },
        ],
        typeId: [
          { required: true, message: '请选择设备类型', trigger: 'blur' }
        ]
      },
      loading: false,
      saving: false,
      loadingFile: false,
    }
  },
  methods: {
    //页面初始化
    init () {
      this.loadModelList()
      this.loadFactoryListAll()
      this.loadTypeListAll()
    },
    //初始化厂家下拉框
    loadFactoryListAll () {
      this.$ajax.get('/base/factory/list_all').then(msg => {
        this.factories = msg
      }).catch(err => {
        this.$message.error(err)
      })
    },
    //初始化设备类型下拉框
    loadTypeListAll () {
      this.$ajax.get('/base/assettype/list_all').then(msg => {
        this.types = msg
      }).catch(err => {
        this.$message.error(err)
      })
    },

    //从后台查询型号列表
    loadModelList () {
      this.loading = true
      this.$ajax.get('/base/model/list', this.queryObj).then(msg => {
        this.pageData = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },
    //初始化添加型号
    add_init () {
      this.editVisible = true
      this.modelInfo = {}
    },
    //初始化型号
    edit_init (row) {
      this.editVisible = true
      this.modelInfo = JSON.parse(JSON.stringify(row))
    },
    //保存型号
    submitModel () {
      this.$refs["modelForm"].validate(valid => {
        if (valid) {
          let url = "/base/model/add";
          if (this.modelInfo.id != null) {
            url = "/base/model/edit";
          }
          this.saving = true
          this.$ajax.post(url, this.modelInfo).then(msg => {
            this.saving = false
            this.loadModelList()
            this.editVisible = false
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
            this.saving = false
          })
        }
      })
    },
    //删除设备型号
    del (delId) {
      let ids = []
      if (delId != null) {
        ids = [delId]
      } else {
        this.$refs["modelTable"].selection.forEach((ele) => {
          ids.push(ele.id)
        })
      }
      if (ids.length > 0) {
        this.loading = true
        this.$ajax.post('/base/model/delete', { 'ids': ids }).then(msg => {
          this.loading = false
          this.$message.success(msg)
          this.queryObj.pageNum = 1//删除之后，回到第一页
          this.loadModelList()
        }).catch(err => {
          this.$message.error(err)
          this.loading = false
        })
      }
    },
    edit_file (row) {
      this.dialogFileVisible = true
      this.fileList = []
      this.modelFileList = []
      this.modelInfo = JSON.parse(JSON.stringify(row))
      if (this.modelInfo.attachFiles != null) {
        this.modelFileList = JSON.parse(this.modelInfo.attachFiles)
      }
      if (this.modelInfo.attachImgs != null && this.modelInfo.attachImgs != '') {
        this.fileList = JSON.parse(this.modelInfo.attachImgs)
        this.fileList.forEach(e => {
          e.url = this.$api + e.url + '&platform=web&token=' + this.$store.getUser().token
        })
      }
    },
    downFile (row) {
      this.loadingFile = true
      const x = new window.XMLHttpRequest();
      x.open('GET', this.$api + row.url + '&platform=web&token=' + this.$store.getUser().token, true);
      x.responseType = 'blob';
      x.onload = () => {
        const url = window.URL.createObjectURL(x.response);
        const a = document.createElement('a');
        a.href = url;
        a.download = row.name;
        a.click();
        this.loadingFile = false
      };
      x.send();
      this.loadingFile = false
    },
    beforeUpload (file) {
      this.loadingFile = true
      const sizeLimit = file.size / 1024 / 1024 > 50
      if (sizeLimit) {
        this.loadingFile = false
        this.$message.warning('上传文件大小不能超过 50MB!')
      }
      return !sizeLimit
    },
    handleSuccess (response, file) {
      console.log(response, file)
      // 存在bug，如果一个页面，同时用两个图片附件
      if (response.code == 200) {
        let tempFileList = new Array()
        if (this.modelInfo.attachFiles != null) {
          tempFileList = JSON.parse(this.modelInfo.attachFiles)
        }
        tempFileList.push({ name: file.name, size: file.size, url: '/file/file/down?filename=' + response.msg })
        this.modelInfo.attachFiles = JSON.stringify(tempFileList)
        this.$ajax.post('/base/model/editFile', { attachFiles: this.modelInfo.attachFiles, id: this.modelInfo.id }).then((msg) => {
          if (this.modelInfo.attachFiles != null) {
            this.modelFileList = JSON.parse(this.modelInfo.attachFiles)
          } else {
            this.modelFileList = []
          }
          this.$message.success(msg)
          this.loadingFile = false
        }).catch(err => {
          this.$message.error(err)
        })
      } else {
        this.$message.error(response.msg)
      }
    },
    delFile (row) {
      this.loadingFile = true
      let s = row.url.indexOf('=')
      let e = row.url.length
      let filename = row.url.substring(s + 1, e)
      let files = JSON.parse(this.modelInfo.attachFiles)
      let newFiles = files.filter((e) => {
        return !e.url.includes(row.url.substring(0, row.url.indexOf('.')))
      })
      let param
      if (newFiles.length == 0) {
        param = null;
      } else {
        param = JSON.stringify(newFiles)
      }
      //物理删除
      this.$ajax.post("/file/file/delete", { fileName: filename }).then((msg) => {
        this.modelInfo.attachFiles = JSON.stringify(newFiles)
        this.$ajax.post('/base/model/editFile', { attachFiles: param, id: this.modelInfo.id }).then(() => {
          if (this.modelInfo.attachFiles != null) {
            this.modelFileList = JSON.parse(this.modelInfo.attachFiles)
          } else {
            this.modelFileList = []
          }
          this.loadingFile = false
          this.$message.success(msg)
        }).catch(err => {
          this.loadingFile = false
          this.$message.error(err)
        })
      }).catch(err => {
        this.loadingFile = false
        this.$message.error(err)
      })
    },
    getUploadAction() {
      return   this.$api+"/file/file/upload";
    },
    handleError () {
      this.loadingFile = false
      this.$message.error("上传附件失败，请确认文件是否超出")
    },
    handleExceed () {
      this.$message.error("超出最大上传附件数")
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped></style>
